export default "/assets/images/hey-google.6b014b1ca119b446.webp";